import React from "react";
import { Link } from "react-router-dom";
import notfound from "../assets/images/404-error.png"
const PageNotFound = () => {
  return (
    <div
      className="d-flex justify-content-center align-items-center flex-column" 
      style={{ minHeight: "70vh" }}
    >
   <img  src={notfound} alt="logo" width={400}/>
      <p className="text-muted ">
        Sorry, the page you are looking for doesn't exist.
      </p>

      <Link to="/" className="btn btn-primary mt-4">
        Go to Dashboard <i class="ri-arrow-right-long-line"></i>
      </Link>
    </div>
  );
};

export default PageNotFound;